import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { ContentLoader, Typography as T, palette } from '@dev/ee-components';

import useMobile from '@/services/hooks/useMobile';
import { getContactsOverviewStore } from '@/store/contacts/actions';
import { DateRangeSelect } from '../DateRange';
import { MobileDateFilter } from '../MobileDateRange';
import { AudiencePerformanceInterface, StyledProps } from '../ContactOverview';

const SectionHeader = styled.div<StyledProps>`
    display: flex;
    padding: 16px 32px;
    line-height: ${({ isMobile }): number => (isMobile ? 20 : 40)}px;
    border-bottom: 1px solid ${palette.gray[3]};
    justify-content: space-between;
    align-items: center;
`;

export const AudiencePerformance: FC<AudiencePerformanceInterface> = (
    props: AudiencePerformanceInterface
): JSX.Element => {
    const { t } = useTranslation();
    const isMobile = useMobile();
    const contactsOverview = useSelector(getContactsOverviewStore);

    return (
        <div className="board">
            <SectionHeader isMobile={false}>
                <T variant="h2">{t('audienceperformance')}</T>
                {isMobile ? (
                    <MobileDateFilter contactsGrowth={false} setContactsGrowthFrom={props.setContactsGrowthFrom} />
                ) : (
                    <DateRangeSelect />
                )}
            </SectionHeader>
            <div className="boardsection split">
                <T variant="body1">{t('avgopen')}</T>
                {!contactsOverview && (
                    <T variant="body1">
                        <ContentLoader count={1} mode="row" width={'60px'} />
                    </T>
                )}
                {contactsOverview && <T variant="h2">{`${contactsOverview?.AverageOpenRate.toFixed(2) || 0} %`}</T>}
            </div>
            <div className="boardsection split">
                <T variant="body1">{t('avgclick')}</T>
                {!contactsOverview && (
                    <T variant="body1">
                        <ContentLoader count={1} mode="row" width={'60px'} />
                    </T>
                )}
                {contactsOverview && <T variant="h2">{`${contactsOverview?.AverageClickRate.toFixed(2) || 0} %`}</T>}
            </div>
        </div>
    );
};

export default AudiencePerformance;
